(() => {
  if (customElements.get('fultons-portento-spin')) return;
  class PortentoSpin extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.dialog = this.closest('[data-gallery-dialog]');
      if (!this.dialog) return;
      this.ready = true;
      this.index = 0;
      this.count = Number(this.dataset.count);
      this.toggle = this.querySelector('[data-spin-toggle]');
      this.status = this.querySelector('.fpspin-status');
      this.photo = this.dialog.querySelector('[data-gallery-full]');
      this.frame = this.photo.parentElement;
      this.caption = this.dialog.querySelector('[data-gallery-dialog-caption]');
      this.previous = this.dialog.querySelector('[data-gallery-prev]');
      this.next = this.dialog.querySelector('[data-gallery-next]');
      if (!this.previous || !this.next) { this.hidden = true; return; }
      this.stage = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.image = this.stage.querySelector('img');
      this.stage.style.setProperty('--fpspin-source-width', (Number(this.image.getAttribute('width')) || 860) * Math.min(2, Math.max(1, Number(this.dataset.displayScale) || 1)) + 'px');
      this.toggle.addEventListener('click', () => this.active ? this.stop(true) : this.start());
      this.dialog.addEventListener('close', () => this.stop(false));
      this.dialog.addEventListener('click', event => {
        if (!this.active) return;
        const button = event.target.closest('[data-gallery-prev],[data-gallery-next]');
        if (!button) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.markInteracted();
        this.show(this.index + (button === this.previous ? -1 : 1), true);
      }, true);
      this.dialog.addEventListener('keydown', event => {
        if (!this.active) return;
        const directions = {ArrowLeft: -1, ArrowRight: 1};
        if (event.key in directions) { event.preventDefault(); event.stopImmediatePropagation(); this.markInteracted(); this.show(this.index + directions[event.key], true); }
        else if ((event.key === 'Home' || event.key === 'End') && event.target === this.stage) { event.preventDefault(); event.stopImmediatePropagation(); this.markInteracted(); this.show(event.key === 'Home' ? 0 : this.count - 1, true); }
      }, true);
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, index: this.index, active: false};
      });
      this.stage.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        if (!drag.active) {
          if (Math.abs(dx) < 8) return;
          drag.active = true;
          this.markInteracted();
          this.stage.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.show(drag.index + Math.round(dx / 14), false);
      });
      const finish = event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const active = this.drag.active;
        this.drag = null;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        if (active) this.announce();
      };
      this.stage.addEventListener('pointerup', finish);
      this.stage.addEventListener('pointercancel', finish);
      this.stage.addEventListener('lostpointercapture', event => {
        if (event.target === this.stage && this.drag?.id === event.pointerId && !this.stage.hasPointerCapture(event.pointerId)) this.drag = null;
      });
    }
    markInteracted() {
      if (this.spinHintDismissed) return;
      this.spinHintDismissed = true;
      this.dispatchEvent(new CustomEvent('fultons:spin-interacted'));
    }
    start() {
      if (this.active) return;
      this.saved = {caption: this.caption.textContent, previous: this.previous.textContent, next: this.next.textContent};
      this.active = true;
      this.photo.hidden = true;
      this.frame.append(this.stage);
      this.previous.textContent = this.dataset.previous;
      this.next.textContent = this.dataset.next;
      this.caption.textContent = this.dataset.caption + ' ' + this.dataset.help;
      this.toggle.textContent = this.dataset.back;
      this.toggle.setAttribute('aria-pressed', 'true');
      if (!this.frames) this.load(); else this.show(this.index, false);
      this.stage.focus({preventScroll: true});
    }
    stop(focus) {
      if (!this.active) return;
      this.active = false;
      this.drag = null;
      this.stage.remove();
      this.photo.hidden = false;
      this.previous.textContent = this.saved.previous;
      this.next.textContent = this.saved.next;
      this.caption.textContent = this.saved.caption;
      this.toggle.textContent = this.dataset.open;
      this.toggle.setAttribute('aria-pressed', 'false');
      this.status.textContent = '';
      if (focus) this.toggle.focus({preventScroll: true});
    }
    load() {
      this.status.textContent = this.dataset.loading;
      const spinFirst = this.spinSourceFirst ||= (window.matchMedia('(min-width:750px)').matches && this.dataset.firstLarge) || this.dataset.first;
      this.frames = Array.from({length: this.count}, (_, index) => {
        const image = new Image();
        const source = new URL(spinFirst, location.href);
        source.pathname = source.pathname.replace(/-00\.(png|webp)$/, (_, extension) => '-' + String(index).padStart(2, '0') + '.' + extension);
        if (index) source.search = '';
        image.onload = () => { if (this.active && this.index === index) this.show(index, false); };
        image.onerror = () => { image.failed = true; if (this.active && this.index === index) this.status.textContent = this.dataset.error; };
        image.src = source.href;
        return image;
      });
      this.show(0, false);
    }
    show(index, announce) {
      if (!this.active || !this.frames) return;
      this.index = (index % this.count + this.count) % this.count;
      const frame = this.frames[this.index];
      if (frame.failed) { this.status.textContent = this.dataset.error; return; }
      if (!frame.complete || !frame.naturalWidth) { this.status.textContent = this.dataset.loading; return; }
      this.image.src = frame.src;
      this.status.textContent = '';
      if (announce) this.announce();
    }
    announce() {
      const frame = this.frames?.[this.index];
      if (!this.active || !frame?.complete || !frame.naturalWidth) return;
      this.status.textContent = this.dataset.position.replace('{current}', String(this.index + 1)).replace('{total}', String(this.count));
    }
  }
  customElements.define('fultons-portento-spin', PortentoSpin);
})();
